import {_formatPrice} from '../../Utils/tools'
import InfoCard from '../Card/InfoCard'
import alertIcon from '../../assets/img/alert-icon.svg'
import noRefundIcon from '../../assets/img/no-refund-icon.svg'
import PrescriptionAlert from '../Alerts/PrescriptionAlert'
import ReactTooltip from 'react-tooltip'
import {useSelector} from 'react-redux'

function ProductSummary({
  title,
  buttonText,
  products,
  totalCart,
  onClickAction,
  className,
  refundElement,
  applyRefund,
  insurancePolicyLimit,
  applyDeductible,
  insuranceError,
  onClickApplyRefund,
  discountRefund,
  modifyCart,
  refund,
  show,
  pressedButton,
  isSubscription,
}) {
  const enabledInsurance = useSelector((state) => state.app?.enabledInsurance)

  return (
    <div
      className={`content-checkout-medication-detail content-bg-white-resposive ${className}`}>
      <h5 className="txt-paragraph--bold mt-2 mb-3 w-100">{title}</h5>
      {products?.map((el, key) => {
        let quantity = el.counter
          ? el.counter
          : el?.quantity
          ? el?.quantity
          : null
        let show =
          process.env.REACT_APP_PROFILE === 'INSURANCE' ||
          (enabledInsurance && !isSubscription)

        return (
          <div key={key} className="w-100">
            <div className="d-flex w-100 justify-content-between align-items-center mb-1">
              {el.loadedPrescription && show && el?.product?.client_product_id && (
                <>
                  <img
                    src={alertIcon}
                    alt="Alert"
                    data-tip="Agrega tu receta médica para calcular tu reembolso"
                    data-for="tootip-payment-desktop"
                    className="tooltip-hover"
                  />
                  <ReactTooltip
                    id="tootip-payment-desktop"
                    className="tooltip-style shadow rounded-3 title-primary--regular text-center p-3 maxw-250"
                    effect="solid"
                    place="bottom"
                    backgroundColor="#ffffff"
                    textColor="#000000"
                    arrowColor="#FFFFFF"
                  />
                  <img
                    src={alertIcon}
                    alt="Alert"
                    data-tip="Agrega tu receta médica para calcular tu reembolso"
                    data-for="tootip-payment-responsive"
                    data-event="click focus"
                    className="tooltip-click"
                  />
                  <ReactTooltip
                    id="tootip-payment-responsive"
                    globalEventOff="click"
                    className="tooltip-style shadow rounded-3 title-primary--regular text-center p-3 maxw-250"
                    effect="solid"
                    place="bottom"
                    backgroundColor="#ffffff"
                    textColor="#000000"
                    arrowColor="#FFFFFF"
                  />
                </>
              )}

              {show && !el?.product?.client_product_id && (
                <>
                  <img
                    src={noRefundIcon}
                    alt="Producto no reembolsable"
                    data-tip="Este medicamento no es reembolsable a través de Yapp"
                    data-for="tootip-payment-desktop"
                    className="mr-1 tooltip-hover"
                  />
                  <ReactTooltip
                    id="tootip-payment-desktop"
                    className="tooltip-style shadow rounded-3 title-primary--regular text-center p-3 maxw-250"
                    effect="solid"
                    place="bottom"
                    backgroundColor="#ffffff"
                    textColor="#000000"
                    arrowColor="#FFFFFF"
                  />
                  <img
                    src={noRefundIcon}
                    alt="Producto no reembolsable"
                    data-tip="Este medicamento no es reembolsable a través de Yapp"
                    data-for="tootip-payment-responsive"
                    data-event="click focus"
                    className="tooltip-click"
                  />
                  <ReactTooltip
                    id="tootip-payment-responsive"
                    globalEventOff="click"
                    className="tooltip-style shadow rounded-3 title-primary--regular text-center p-3 maxw-250"
                    effect="solid"
                    place="bottom"
                    backgroundColor="#ffffff"
                    textColor="#000000"
                    arrowColor="#FFFFFF"
                  />
                </>
              )}

              <p className="txt-line w-100 line-14">{el?.name}</p>
              <div className="d-flex justify-content-between mw-80">
                <p className="txt-line mr-2">x{quantity}</p>
                <p className="txt-line">{_formatPrice(el.price * quantity)}</p>
              </div>
            </div>
            {(applyRefund || insurancePolicyLimit || applyDeductible) && (
              <div className="d-flex justify-content-between w-100 mb-2">
                <div className="d-flex align-items-center">
                  {el.refund ? (
                    <p className="txt-line txt-bold color-insurance mr-1">
                      Reembolso Seguros SURA
                    </p>
                  ) : (
                    <p className="txt-line txt-bold color-insurance mr-1">
                      {el.loadedPrescription &&
                      show &&
                      el?.product?.client_product_id
                        ? 'No aplica reembolso'
                        : !el?.product?.client_product_id
                        ? 'No reembolsable'
                        : 'No aplica reembolso'}
                    </p>
                  )}
                </div>
                <div>
                  <p className="txt-line txt-bold color-insurance">
                    {([undefined, null, 0].includes(refund?.value) ? '' : '-') +
                      _formatPrice(el.refund)}
                  </p>
                </div>
              </div>
            )}
          </div>
        )
      })}

      {[null, undefined, 0].includes(products?.length) && (
        <p className="txt-line mr-2">Sin productos</p>
      )}

      <hr className="w-100 mx-0 mb-2 hr--gray" />
      <div className="d-flex w-100 justify-content-between mb-3">
        <p className="txt-line">Subtotal</p>
        <p className="txt-line">{_formatPrice(totalCart)}</p>
      </div>
      <div className="w-100">
        {modifyCart && (
          <div
            id="gtm-webapp-checkout-btn-add-product"
            className="btn-link-add-medication c-pointer"
            onClick={onClickAction}>
            <i className="icon-circle-plus" />{' '}
            <span className="m-0 ml-2">{buttonText}</span>
          </div>
        )}

        {insurancePolicyLimit && (
          <InfoCard
            text="Has llegado al tope de tu póliza"
            icon="icon-info-2"
            className="apply-refund"
            borderColor={'--color-error-ds'}
            bgColor={'--color-white'}
            iconColor={'--color-error-ds'}
            fontColor={'--color-error-ds'}
          />
        )}
        {insuranceError && (
          <InfoCard
            text="Error al liquidar"
            icon="icon-info-2"
            className="apply-refund"
            borderColor={'--color-error-ds'}
            bgColor={'--color-white'}
            iconColor={'--color-error-ds'}
            fontColor={'--color-error-ds'}
          />
        )}

        {applyDeductible && (
          <InfoCard
            text="Aplica deducible"
            icon="icon-info-2"
            className="apply-refund"
            borderColor={'--color-dark-blue-ds'}
            bgColor={'--color-white'}
            iconColor={'--color-dark-blue-ds'}
            fontColor={'--color-dark-blue-ds'}
          />
        )}
        {(products?.some(
          (c) => show && !isSubscription && c?.product?.client_product_id,
        ) ||
          (enabledInsurance && !isSubscription)) && (
          <>
            {products?.some(
              (c) => c?.loadedPrescription && c?.product?.client_product_id,
            ) &&
              pressedButton && (
                <PrescriptionAlert
                  text={
                    'Para acceder al reembolso de tus medicamentos debes agregar una receta médica'
                  }
                  alt={'Se necesita receta médica'}
                />
              )}
            <div className="px-4">
              <button
                className="btn-default--small background-insurance color-white btn-stroke font--12 mx-auto is-small size-content-responsive-btn w-md-100 apply-refund"
                onClick={onClickApplyRefund}>
                Calcular reembolso
              </button>
            </div>
          </>
        )}

        {/* {refundElement &&
          !applyRefund &&
          !insurancePolicyLimit &&
          !applyDeductible &&
          ![undefined, null, ''].includes(show) &&
          products.filter(
            (c) => ![undefined, null].includes(c.product?.client_product_id),
          ).length > 0 && (
           
          )} */}
      </div>
    </div>
  )
}

export default ProductSummary
